import translations from './MarketList.translations'

// The minimum percentage of the target price that the minimum price must reach
// for the backpricer to be activated.
export const LISTING_PRICE_DIFFERENCE_LIMIT_IN_PERCENTAGE = 85

// Maximum target price = minimum price * LISTING_PRICE_DIFFERENCE_MAXIMUM_TARGET_PRICE_MULTIPLIER
export const LISTING_PRICE_DIFFERENCE_MAXIMUM_TARGET_PRICE_MULTIPLIER = 1.08

export const MARKET_LIST_TYPES = {
  WITH_BACKBOX: 'withBackbox',
  WITHOUT_BACKBOX: 'withoutBackbox',
  OFFLINE: 'offline',
}

export const MARKET_LIST_TYPES_LABELS = {
  [MARKET_LIST_TYPES.WITH_BACKBOX]: translations.withBackbox,
  [MARKET_LIST_TYPES.WITHOUT_BACKBOX]: translations.withoutBackbox,
  [MARKET_LIST_TYPES.OFFLINE]: translations.offline,
}

export const PRICE_IS_TO_LOW_RULE = {
  REQUIRED_MINIMUN_TARGET_PRICE: 100,
  LIMIT_IN_PERCENTAGE: Number(LISTING_PRICE_DIFFERENCE_LIMIT_IN_PERCENTAGE),
  MAXIMUM_TARGET_PRICE_MULTIPLIER: Number(
    LISTING_PRICE_DIFFERENCE_MAXIMUM_TARGET_PRICE_MULTIPLIER,
  ),
}
